import {createContext, ReactNode, useContext} from 'react'
import {createPortal} from 'react-dom'

// Each canvas owns an overlay outside its translated/scaled world.
export const WidgetFullEditorHostContext = createContext<HTMLDivElement | null>(null)

export const isWidgetFullEditorTarget = (target: EventTarget | null) =>
    target instanceof Element && target.closest('.canvas-widget-full-editor') !== null

export const WidgetFullEditorPortal = ({children}: {children: ReactNode}) => {
    const host = useContext(WidgetFullEditorHostContext)
    if (!host) return null

    return createPortal(
        <div className="canvas-widget-full-editor" onContextMenu={event => event.stopPropagation()}>
            {children}
        </div>,
        host,
    )
}
